module.exports = __webpack_public_path__ + "img/scheduler.6a79826b.svg";